import React, { useEffect, useState } from "react";
import { Card } from "@/components/ui/card";
import { api } from "@/lib/http";
import { fmtCurrency } from "@/lib/calc";
import { Landmark } from "lucide-react";
import { PayoutReconcileDialog } from "@/components/booking/PayoutReconcileDialog";

const fmtDay = (iso) => { try { return new Date(iso + "T00:00:00").toLocaleDateString("en-AU", { weekday: "short", day: "numeric", month: "short" }); } catch { return iso; } };

export const PayoutsCard = ({ cur }) => {
  const [p, setP] = useState(null);
  const [rec, setRec] = useState("");
  useEffect(() => { api.get("/dashboard/payouts").then(({ data }) => setP(data)).catch(() => setP({ connected: false })); }, []);
  if (!p) return null;
  const c = p.currency || cur;
  return (
    <Card className="rounded-2xl p-5" data-testid="dashboard-payouts">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2"><Landmark className="h-4 w-4 text-primary" /><span className="font-mono-label text-[11px] uppercase tracking-wider text-muted-foreground">Stripe payouts</span></div>
        {p.payout_schedule?.delay_days && <span className="text-[11px] text-muted-foreground">{p.payout_schedule.interval || "daily"} · {p.payout_schedule.delay_days} business day{p.payout_schedule.delay_days === 1 ? "" : "s"}</span>}
      </div>
      {!p.connected ? <p className="text-sm text-muted-foreground" data-testid="payouts-not-connected">Connect Stripe in Business details to see upcoming payouts.</p>
        : p.error ? <p className="text-sm text-muted-foreground">{p.error}</p> : (
        <div className="space-y-3">
          <div className="grid grid-cols-3 gap-2">
            <div><div className="text-[11px] text-muted-foreground">Next payout</div><div className="font-heading font-bold text-lg tabular-nums" data-testid="payouts-next">{p.next ? fmtCurrency(p.next.amount, c, 2) : "—"}</div>{p.next && <div className="text-[11px] text-muted-foreground">{fmtDay(p.next.arrival_date)}</div>}</div>
            <div><div className="text-[11px] text-muted-foreground">On its way</div><div className="font-heading font-bold text-lg tabular-nums" data-testid="payouts-in-transit">{fmtCurrency(p.in_transit_total, c, 2)}</div></div>
            <div><div className="text-[11px] text-muted-foreground">Still settling</div><div className="font-heading font-bold text-lg tabular-nums" data-testid="payouts-pending">{fmtCurrency(p.pending, c, 2)}</div><div className="text-[11px] text-muted-foreground">+ {fmtCurrency(p.available, c, 2)} available</div></div>
          </div>
          {p.payouts.length > 0 && (
            <div className="divide-y rounded-lg border text-sm" data-testid="payouts-list">
              {p.payouts.slice(0, 5).map((r) => (
                <button key={r.id} onClick={() => setRec(r.id)} className="w-full flex items-center justify-between px-3 py-1.5 hover:bg-muted/60 text-left" title="Reconcile this payout" data-testid={`payout-row-${r.id}`}>
                  <span className="text-muted-foreground">{fmtDay(r.arrival_date)}</span>
                  <span className={`text-[11px] px-1.5 rounded-full border ${r.status === "paid" ? "text-primary border-primary/40" : r.status === "failed" ? "text-destructive border-destructive/40" : "text-muted-foreground"}`}>{r.status.replace("_", " ")}</span>
                  <span className="tabular-nums font-semibold">{fmtCurrency(r.amount, c, 2)}</span>
                </button>
              ))}
            </div>
          )}
          <p className="text-[11px] text-muted-foreground">Tap a payout to reconcile it against your sales.</p>
        </div>
      )}
      <PayoutReconcileDialog payoutId={rec} cur={c} onClose={() => setRec("")} />
    </Card>
  );
};
